import axios from "axios";

export default {
  actions: {
    postAsync: ({ commit }, { path, formData }) => {
      return new Promise((resolve, reject) => {
        formData.append("format", "json");
        axios.post(path, formData).then(response => {
          const { data } = response;
          if (data.notice) {
            flash({ type: "notice", message: data.notice, commit });
            resolve();
          } else if (data.error) {
            flash({ type: "error", message: data.error, commit });
            reject();
          }
        });
      });
    },
    setCurrentLocale: ({ commit }, data) => commit("setCurrentLocale", data),
    setCurrentCityUrl: ({ commit }, data) => commit("setCurrentCityUrl", data),
    toggleNavigationState: ({ commit }, data) => commit("toggleNavigationState", data),
    toggleSearchState: ({ commit }, data) => commit("toggleSearchState", data),
    setGlobalToggle: ({ commit }, data) => commit("setGlobalToggle", data),
    addTabToErrors: ({ commit }, id) => commit("addTabToErrors", id),
    setGlobalTabs: ({ commit, state }, { mutateUrl, scrollTo = false, data }) => {
      commit("setGlobalTabs", data);
      if (mutateUrl) {
        window.location.hash = Object.entries(state.globalTabs)
          .map(hash => hash.join("="))
          .join("&");
      }
      if (scrollTo) {
        let el = document.querySelector(`a[name=${Object.values(data)[0]}]`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
    showModal: ({ commit }, modalName) => commit("showModal", modalName),
    hideModal: ({ commit }, modalName) => commit("hideModal", modalName),
    fetchCsrfToken: ({ commit, state }) => {
      return new Promise(resolve => {
        if (state.csrfToken.caching) {
          state.csrfToken.promise.then(data => resolve(data));
        } else {
          commit("setCsrfTokenCaching", true);
          const cachePromise = new Promise(cacheResolve => {
            axios
              .get(`/users/csrf_token.json`)
              .then(response => {
                commit("setCsrfToken", {
                  token: response.data.data,
                  resolve,
                  cacheResolve,
                });
              })
              .catch(error => {
                flashError(error, commit);
                resolve();
                cacheResolve();
              });
          });
          commit("setCsrfTokenPromise", cachePromise);
        }
      });
    },
  },
  getters: {
    getCsrfToken: state => state.csrfToken.token,
    getCurrentLocale: state => state.currentLocale,
    getCurrentCityUrl: state => state.currentCityUrl,
    getNavigationOpenState: state => state.navigationOpen,
    getSearchOpenState: state => state.searchOpen,
    getOpenModals: state => state.openModals,
    getGlobalToggles: state => state.globalToggles,
    getGlobalTabs: state => state.globalTabs,
    getErrorTabs: state => state.errorTabs,
  },
  mutations: {
    setGlobalToggle: (state, data) => {
      state.globalToggles = {
        ...state.globalToggles,
        [data.key]: data.value,
      };
    },
    setCsrfTokenPromise: (state, promise) => {
      state.csrfToken.promise = promise;
    },
    setCsrfTokenCaching: (state, bool) => {
      state.csrfToken.caching = bool;
    },
    addTabToErrors: (state, id) => {
      state.errorTabs = [...new Set([...state.errorTabs, id])];
    },
    setGlobalTabs: (state, data) => {
      state.globalTabs = {
        ...state.globalTabs,
        ...data,
      };
    },
    setCurrentLocale: (state, locale) => {
      state.currentLocale = locale;
    },
    setCurrentCityUrl: (state, url) => {
      state.currentCityUrl = url;
    },
    setCsrfToken: (state, { token, resolve, cacheResolve }) => {
      state.csrfToken.token = token;
      cacheResolve();
      resolve();
    },
    toggleNavigationState: state => {
      state.navigationOpen = !state.navigationOpen;
    },
    toggleSearchState: state => {
      state.searchOpen = !state.searchOpen;
    },
    showModal: (state, modalName) => {
      state.openModals = [...new Set([...state.openModals]).add(modalName)];
    },
    hideModal: (state, modalName) => {
      const openModals = new Set([...state.openModals]);
      openModals.delete(modalName);
      state.openModals = [...openModals];
    },
  },
  state: {
    csrfToken: {
      token: "",
      caching: false,
      promise: null,
    },
    currentLocale: "",
    currentCityUrl: "",
    navigationOpen: false,
    searchOpen: false,
    openModals: [],
    globalToggles: {},
    globalTabs: {},
    errorTabs: [],
  },
};

const flash = ({ type, message, commit }) =>
  commit("flashMessages/setMessages", [[type, message]], {
    root: true,
  });

const flashError = (error, commit) => {
  commit("flashMessages/setMessages", [["error", error.response.data.error]], {
    root: true,
  });
};
